import { customElement } from 'aurelia-framework';

@customElement('table-with-toolbar')
export class TableWithToolbar { }
